import React from 'react';
import { useLocation } from 'react-router-dom';
import { useInboxNotifications } from '@/hooks/crm/useInboxNotifications';
import { useUnreadCount } from '@/hooks/crm/useUnreadCount';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useHasCrmAccess } from '@/hooks/crm/useHasCrmAccess';
import { StoreFeature } from '@/types/networkUser';

const EXCLUDED_PREFIXES = [
  '/login',
  '/escolher-ambiente',
  '/esqueci-senha',
  '/redefinir-senha',
  '/cadastro-corretor',
  '/corretor',
  '/portal-corretor',
  '/super-admin',
  '/vitrine',
  '/crm/chat', // o próprio Chat tem listener que ignora a conversa aberta
];

const Listener: React.FC = () => {
  const { totalUnread } = useUnreadCount();
  useInboxNotifications(undefined, totalUnread);
  return null;
};

const Gate: React.FC = () => {
  const { useUserFeatures, hasFeatureInResult } = useUserAccess();
  const { data, isLoading } = useUserFeatures();
  const { hasCrmAccess, isLoading: loadingCrm } = useHasCrmAccess();

  if (isLoading || loadingCrm || !data?.features) return null;
  if (!hasFeatureInResult(data.features, StoreFeature.CRM)) return null;
  if (!hasCrmAccess) return null;
  return <Listener />;
};

/** Ponto único dos avisos do CRM (mensagens e ligações) em todo o sistema da equipe. */
const GlobalCrmNotifications: React.FC = () => {
  const { pathname } = useLocation();
  if (pathname === '/') return null;
  if (EXCLUDED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return null;
  return <Gate />;
};

export default GlobalCrmNotifications;
